<template>
  <el-cascader
    style="width: 100%"
    size="mini"
    v-model="state"
    :options="options"
    :props="{value: 'id', label: 'reasonLabel', children: 'children'}"
    @change="handleChange"
    ref="transactionExpense"
    :disabled="disabled"
    :clearable="clearable"
    :show-all-levels="true">
  </el-cascader>
</template>
<script>
import { validatenull } from '@/tdcommon/validate'
import { fetchExpenseTree } from '@/api/tms/tmstransactionnew'
// 联合单据异动单编辑页面：费用类型下拉级联列表
export default {
  name: 'd2-container-transaction-expense-type',
  data () {
    return {
      options: [],
      modelValue: '1',
      state: this.stringToArray()
    }
  },
  props: {
    value: {
      type: String,
      default: () => ''
    },
    label: {
      type: String,
      default: () => ''
    },
    clearable: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    mdmstr: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    // 数据进行String to ArrayList
    stringToArray () {
      // 分割成字符串数组，再转为 数字数组
      return validatenull(this.value) ? [] : this.value.split(',').map(Number)
    },
    // 获取表格数据
    getList () {
      fetchExpenseTree().then(response => {
        this.options = this.getTreeData(response.data)
      })
      // this.stringToArray()
    },
    handleChange () {
      if (this.state.length > 0) {
        // console.log('handleChange', this.state)
        // console.log('this.$refs[\'transactionExpense\'].getCheckedNodes()', this.$refs['transactionExpense'].getCheckedNodes())
        let thsName = this.$refs['transactionExpense'].getCheckedNodes()[0].pathLabels.join('-')
        let val = { value: this.state.toString(), label: thsName }
        this.$emit('change', val)
      }
    },
    // 最后一级children为空时，递归方式设为不显示
    getTreeData (data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          data[i].children = undefined
          // if (this.modelValue !== '2') {
          //   if (data[i].parentId === 1 && (data[i].id === 14 || data[i].id === 25 || data[i].id === 26 || data[i].id === 28 || data[i].id === 17)) {
          //     data[i].disabled = false
          //   } else {
          //     data[i].disabled = true
          //   }
          // }
        } else {
          this.getTreeData(data[i].children)
        }
      }
      return data
    },
    getStartValues (val) {
      if (!validatenull(this.mdmstr)) {
        let model = this.$parent.elForm.model[this.mdmstr]
        // this.modelValue = model
        // this.getList()
        if (!validatenull(model)) {
          this.values = model
        } else {
          this.values = ''
        }
      }
    }
  },
  watch: {
    state: function (val, oldVal) {
      this.$emit('input', val.toString())
    },
    value: function (val, oldVal) {
      if (!validatenull(val)) {
        this.state = val.split(',')
      } else {
        this.state = []
      }
    }
  },
  mounted () {
    this.getList()
    // this.getStartValues()
  }
}
</script>

<style lang="scss" scoped>
  .td-autocomplete {
    li {
      line-height: normal;
      padding: 7px;
      .name {
        font-size: 16px;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .addr {
        font-size: 12px;
        color: #b4b4b4;
      }
      .highlighted .addr {
        color: #ddd;
      }
    }
  }
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-transaction-expense-type/index.vue"
}
</vue-filename-injector>
